import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Agendamentos: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Agendamentos
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1">
          Módulo de agendamentos em desenvolvimento...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Agendamentos;

